import React from "react";

export default function Payments() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">Payments</h2>
        </div>
      </div>
    </div>
  );
}
